"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexDimensions = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var throttle_1 = tslib_1.__importDefault(require("lodash/throttle"));
var pickBy_1 = tslib_1.__importDefault(require("lodash/pickBy"));
var domUtilities_1 = require("../utils/domUtilities");
/**
 * @internal
 */
var FlexDimensions = /** @class */ (function (_super) {
    tslib_1.__extends(FlexDimensions, _super);
    function FlexDimensions(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapperRef = react_1.createRef();
        _this.updateSize = function () {
            var _a = domUtilities_1.elementRegion(_this.wrapperRef.current), width = _a.width, height = _a.height;
            _this.setState({
                width: width,
                height: height,
            });
        };
        _this.state = {
            width: 0,
            height: 0,
        };
        _this.throttledUpdateSize = throttle_1.default(_this.updateSize, 250, { leading: false });
        return _this;
    }
    FlexDimensions.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.throttledUpdateSize);
        this.throttledUpdateSize();
    };
    FlexDimensions.prototype.componentWillUnmount = function () {
        this.throttledUpdateSize.cancel();
        window.removeEventListener("resize", this.throttledUpdateSize);
    };
    FlexDimensions.prototype.getChildrenDimensions = function () {
        var _this = this;
        return pickBy_1.default(this.state, function (_, key) {
            var setWidth = _this.props.measureWidth && key === "width";
            var setHeight = _this.props.measureHeight && key === "height";
            return setWidth || setHeight;
        });
    };
    FlexDimensions.prototype.renderChildren = function () {
        var child = react_1.default.Children.only(this.props.children);
        return react_1.default.cloneElement(child, this.getChildrenDimensions());
    };
    FlexDimensions.prototype.render = function () {
        var classNames = classnames_1.default(this.props.className);
        return (react_1.default.createElement("div", { ref: this.wrapperRef, className: classNames }, this.renderChildren()));
    };
    FlexDimensions.defaultProps = {
        children: false,
        className: "",
        measureWidth: true,
        measureHeight: true,
    };
    return FlexDimensions;
}(react_1.Component));
exports.FlexDimensions = FlexDimensions;
//# sourceMappingURL=FlexDimensions.js.map